class Instagram {
  constructor() {
    let feed = $('.js-instagram-feed'),
        token = '3108266.4bec629.103fc842c513424f8c5cf28e967c1438',
        username = feed.data('username'),
        limit = feed.data('limit');

    this.fetchPosts(feed, token, username, limit);
  }

  fetchPosts(feed, token, username, limit) {
    $.ajax({
      url: 'https://api.instagram.com/v1/users/self/media/recent',
      dataType: 'jsonp',
      type: 'GET',
      data: {
        access_token: token,
        count: limit
      },
      success: function(resp){
        let post = null;
        for(post in resp.data){
          $(`<div class="card -instagram col-xs-6">
              <div class="card-content">
                <a target="_blank" href="${resp.data[post].link}" class="link -block"></a>
                <div class="card-figure">
                  <div class="card-image bg-cover" style="background-image: url(${resp.data[post].images.standard_resolution.url});"></div>
                </div>
              </div>
            </div>`).appendTo(feed);
        }
      },
      error: function(resp){

      }
    });
  }
}

export default Instagram;
